<template>
  <g class="hc-vertical-axis" fill="none" font-size="10" :text-anchor="axis.anchor" :transform="transform">
    <text 
      v-for="(legend, index) in legends"
      :key="'legend-' + index"
      class="hc-vertical-axis-tick-text"
      stroke-width="0"
      :dy="30 + 20 * scale * index"
    >{{legend}}</text>
    <g
      v-for="(tick, index) in axis.ticks"
      :key="index"
      class="hc-vertical-axis-tick"
      :transform="transformTick(tick.transform)">
      <text
        :transform="'scale(' + scale + ')'"
        class="hc-vertical-axis-tick-text"
        stroke-width="0"
        :x="tick.text.x"
        :y="tick.text.y"
        :dy="tick.text.dy"
      >
        {{tick.text.text}} {{unit}}
      </text>
    </g>
  </g>
</template>

<script>
import { axis } from 'd3-axis-norender'
// import transform from '../addons/transform'
export default {
  name: 'VerticalAxis',
  props: {
    scaleFunction: {
      type: Function,
      default () {
        return []
      }
    },
    color: {
      type: String,
      default: '#757575'
    },
    width: {
      type: Number,
      default: 1000
    },
    offset: {
      type: Object,
      default () { return { top: 24, left: 48, bottom: 48, right: 48 }}
    },
    scale: {
      type: Number,
      default: 1
    },
    data: {
      type: Array,
      default () { return []}
    },
    legends: {
      type: Array,
      default () { return []}
    },
    unit: {
      type: String,
      default: ''
    }
  },
  methods: {
    transformTick (tick) {
      return `translate(${tick.x}, ${tick.y})`
    }
  },
  computed: {
    axis () {
      return axis(2, this.scaleFunction).ticks(8).tickFormat(d => d)()
    },
    transform () {
      return `translate(${this.offset.right}, ${this.offset.bottom})`
    }
  }
}
</script>

<style>

</style>
